import AdminApi from '../services/api';
import swal from 'sweetalert2';

/* init */

const AdminApiService = new AdminApi()

export default{

    props: ['show', 'driver'],

    data() {
        return {
            title: 'Dodaj verziju',
            isLoading: false,
            model: {
                system: 'ANDROID',
                mandatory: false,
                version: 0,
                courierNotes: '',
                companyNotes: ''
            },
            hasError: ''
        };
    },

    watch: {
        show: function(val, oldVal) {
            if(val === true){
                this.reset();
            }
        },
        system: function(val, oldVal) {
            this.hasError = '';
        },
        phoneNumber: function(val, oldVal) {
            this.hasError = '';
        },
        courierNotes: function(val, oldVal) {
            this.hasError = '';
        },
        companyNotes: function(val, oldVal) {
            this.hasError = '';
        }
    },

    methods: {
        close() {
            this.$topnavbar.$emit('closeAddVersion')
        },
        successUpdate(){
            this.$topnavbar.$emit('successAddVersion')
        },
        addVersion: addVersion,
        checkNull: checkNull,
        reset: reset,
    }
}


function addVersion() {
    if(this.model.version === 0 ||
        this.model.system.length === 0 ) {
        this.hasError = "Molimo verziju i sistem";
        return;
    }
    let _self = this;
    _self.isLoading = true;

    AdminApiService.addVersions(_self.model)
        .then((response) => {
            _self.reset();
            _self.isLoading = false;
            _self.successUpdate();
        }).catch((error) => {
            _self.isLoading = false;
            try{
                _self.hasError = "Greška: "+ error.data.message;
            }catch (e) {
                _self.hasError = "Greška prilikom dodavanja."
            }
        })

}

function reset() {
    this.model.system = '';
    this.model.version = 0;
    this.model.mandatory = true;
    this.model.courierNotes = '';
    this.model.companyNotes = '';

}


function checkNull(data) {
    if(data == null) return '';
    return data;
}


// WEBPACK FOOTER //
// ./src/modals/AddVersionModal.js